import { useCallback } from 'react';

import { useCurrentUser } from '../../currentUser/model/useCurrentUser';
import { getProductShell, type ProductShell } from '../lib/productShell';
import { hasShownStartScreen, markStartScreenShown } from '../lib/startScreenSession';
import { useTrialVariant } from './useTrialVariant';

type ProductShellState = {
  markStartScreenShown: () => void;
  status: 'loading' | 'resolved';
} & ProductShell;

export const useProductShell = (): ProductShellState => {
  const { status, variant } = useTrialVariant();
  const { data: userId } = useCurrentUser((user) => user.id);
  const shell = getProductShell(variant);

  const markShown = useCallback(() => {
    if (userId) markStartScreenShown(userId);
  }, [userId]);

  return {
    ...shell,
    markStartScreenShown: markShown,
    startOnTranslation: shell.startOnTranslation && Boolean(userId) && !hasShownStartScreen(userId ?? ''),
    status,
  };
};
